export default __webpack_public_path__ + "static/media/phone.8cce8d02.svg";